import { StreetAddress } from '../streetAddress/streetAddress';
import { RecurringSchedule } from '../recurringPayments/recurringSchedule';
import { TaxList } from '../ui/taxList';
import { L2L3Item } from './L2L3Item';

/*
// This is what the gateway expects:
string     `json:"paymentMethodId"`        // Required - must correspond to customerId
string     `json:"customerId"`             // Required - must correspond to paymentMethodId
types.Verb `json:"verb"`                   // Required (SALE, VOID, REFUND, etc.)
int32      `json:"magnifiedAmount"`        // Required - in cents
bool       `json:"consumerInitiated"`      // Required for initial transaction to recur (true if initial recurring charge)
*string    `json:"originalTransactionId"`  // Required only for VOID or REFUND
*string    `json:"orderId"`                // Required only for VOID or REFUND, will be generated otherwise
string     `json:"invoiceNumber"`          // Optional - will be created if not provided
*/
export class TerminalTransactionRequest {
  paymentMethodId: string;
  customerId: string;
  verb: string;
  currencyCode: string;
  magnifiedAmount: number;
  isRecurring: boolean = false;
  originalTransactionId: string | undefined;
  orderId: string | undefined;
  invoiceNumber: string | undefined;
  poNumber: string | undefined;
  description: string | undefined;
  recipientEmail: string | undefined;
  billingAddress: Partial<StreetAddress> | undefined;
  shippingAddress: Partial<StreetAddress> | undefined;
  recurringSchedule: RecurringSchedule | undefined;
  quantity: number | undefined;
  unitOfMeasure: string | undefined;
  productCode: string | undefined;
  ShippingAndHandlingAmount: number | undefined;
  DutyAmount: number | undefined;
  taxes: TaxList[] = [];
  taxAmount: number | undefined;
  agreementId: string | undefined;
  items: L2L3Item[] = [];

  constructor(transaction: Partial<TerminalTransactionRequest>) {
    if (transaction.paymentMethodId == undefined) {
      throw 'paymentMethodId is required';
    }
    if (transaction.customerId == undefined) {
      throw 'customerId is required';
    }
    if (transaction.verb == undefined) {
      throw 'verb is required';
    }
    if (transaction.magnifiedAmount == undefined) {
      throw 'magnifiedAmount is required';
    }
    if (transaction.currencyCode == undefined) {
      throw 'currencyCode is required';
    }

    this.paymentMethodId = transaction.paymentMethodId;
    this.customerId = transaction.customerId;
    this.verb = transaction.verb;
    this.currencyCode = transaction.currencyCode;
    this.magnifiedAmount = transaction.magnifiedAmount;
    this.originalTransactionId = transaction.originalTransactionId;
    this.orderId = transaction.orderId;
    this.invoiceNumber = transaction.invoiceNumber;
    this.poNumber = transaction.poNumber;
    this.billingAddress = transaction.billingAddress;
    this.shippingAddress = transaction.shippingAddress;
    this.description = transaction.description;
    this.recipientEmail = transaction.recipientEmail;
    this.recurringSchedule = transaction.recurringSchedule;
    this.quantity = transaction.quantity;
    this.unitOfMeasure = transaction.unitOfMeasure;
    this.productCode = transaction.productCode;
    this.ShippingAndHandlingAmount = transaction.ShippingAndHandlingAmount;
    this.taxes = transaction.taxes || [];
    this.DutyAmount = transaction.DutyAmount;
    this.taxAmount = transaction.taxAmount;
    this.agreementId = transaction.agreementId;
    this.items = transaction.items || [];
  }

  static createEmpty(): TerminalTransactionRequest {
    return new TerminalTransactionRequest({
      paymentMethodId: '',
      customerId: '',
      verb: '',
      currencyCode: '',
      magnifiedAmount: 0,
      description: '',
      recipientEmail: '',
      quantity: 1,
      unitOfMeasure: '',
      productCode: '',
      ShippingAndHandlingAmount: 0,
      taxes: [],
      DutyAmount: 0,
      taxAmount: 0,
      invoiceNumber: '',
      poNumber: '',
      agreementId: '',
      items: [],
    });
  }
}
